import React, { Component } from 'react';
import { connect } from 'react-redux';
import AuthRouter from './route/AuthRouter';
import Header from './components/presentation/header/Header';
import Footer from './components/presentation/footer/Footer';
import { getStatusRequest, logoutRequest } from './actions/authentication';
import './App.css';

class App extends Component {
  constructor(props){
    super(props)
    this.props.getStatusRequest().then(
      () => {
        // if session is not valid
        if(!this.props.status.valid) {
          // logout the session
          let loginData = {
              isLoggedIn: false,
              email: ''
          };

          document.cookie='key=' + btoa(JSON.stringify(loginData));
        }
        else{
        }
      }
    );
  }

  handleLogout = () => {
    this.props.logoutRequest().then(
      () => {
        let loginData = {
            isLoggedIn: false,
            email: ''
        };
        document.cookie = 'key=' + btoa(JSON.stringify(loginData));
      }
    );
  }

  render(){
    return(
      <>
        <div id="container">
          <Header />
          <AuthRouter />
        </div>
        <Footer />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      status: state.AuthManager.status
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      getStatusRequest: () => {
          return dispatch(getStatusRequest());
      },
      logoutRequest: () => {
          return dispatch(logoutRequest());
      }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
